import { uniqueBy } from '@debbie/common/dist/util/index.js';
import { h } from '..//index.js';
import { selectMe } from '../me/selectors.js';
export const selectActiveUsers = (state, tenantId) => {
    return state.activeUsers[tenantId] != null
        ? uniqueBy(state.activeUsers[tenantId], (u) => u.id)
        : state.activeUsers[tenantId];
};
export const selectUsersOnCase = (state, caseId) => {
    const me = selectMe(state);
    const tenantId = state.selectedOwners[0];
    if (!tenantId) {
        return null;
    }
    if (!me) {
        return null;
    }
    let users = [];
    const tenantActiveUsers = state.activeUsers[tenantId];
    if (state.activeUsers[tenantId]) {
        users = [
            ...users,
            ...tenantActiveUsers.filter((user) => user.activities.some((a) => a.handle == caseId) && user.id !== me.id),
        ];
    }
    return users != null ? uniqueBy(users, (u) => u.id) : users;
};
export const selectAllUsers = (state) => {
    const users = state.allUsers;
    if (!h.hasData(users)) {
        return null;
    }
    return users.data;
};
export const selectIsAllUsersLoaded = (state) => {
    const users = state.allUsers;
    if (h.isLoaded(users) || h.isReloading(users)) {
        return true;
    }
    return false;
};
//# sourceMappingURL=selectors.js.map